import * as SliderPrimitive from '@radix-ui/react-slider'
import * as React from 'react'

import { cn } from 'src/utils/cn'

interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  showCircle?: boolean
  showValue?: boolean
  defaultValue?: number[]
}

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, SliderProps>(
  ({ className, showCircle = false, showValue = false, defaultValue = [0], ...props }, ref) => (
    <div className="flex gap-3">
      <SliderPrimitive.Root
        ref={ref}
        defaultValue={defaultValue}
        className={cn('relative flex w-full touch-none select-none items-center', className)}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-accent">
          <SliderPrimitive.Range className="absolute h-full bg-secondary" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          className={cn(
            'block size-5 rounded-full outline outline-4 outline-white transition-colors disabled:pointer-events-none disabled:opacity-50',
            showCircle && 'bg-secondary',
          )}
        />
      </SliderPrimitive.Root>
      {showValue && (
        <div className="flex items-center justify-center rounded-lg border bg-accent px-4 py-1.5 shadow-md">
          <span className="text-sm font-medium">{props.value?.[0]}%</span>
        </div>
      )}
    </div>
  ),
)

Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
